"use strict";

angular.module("imagetrend.components").directive("hlpAlphaFilter", [
    "Resource",
    function(Resource) {
        return {
            restrict: "AE",
            transclude: true,
            replace: true,
            scope: {
                //attributes
                alphaFilter: "=?"
            },
            require: "^hlpList",
            templateUrl: "templates/list/alpha-filter/alpha-filter.html",
            link: function(scope, elem, attrs, ctrl) {
                scope.options = Resource.alpha();

                scope.change = ctrl.alphaFilterChanged;
            }
        };
    }
]);
